import Styles from './styles.module.css';
import Logo from './../../../image/home/logo.png';
import { FaAngleDown } from "react-icons/fa";
import { motion, AnimatePresence } from "framer-motion";
import { useEffect, useState } from 'react';
import { IoReorderThreeOutline } from "react-icons/io5";
import memorii from "./../../../image/home/links/memorii.png";
import Instagram from "./../../../image/home/links/instagram.png";
import Tiktok from "./../../../image/home/links/tiktok.png";
import { useNavigate } from 'react-router-dom';

type HomeNavigationProps = {
  onScrollToProblem: () => void;
  onScrollToService: () => void;
  onScrollToPoint: () => void;
  /** 旧「その他の機能」への遷移。セクション廃止のため未使用（about/contact が渡すため型は残置） */
  onScrollToFunctions?: () => void;
};

const HomeNavigation: React.FC<HomeNavigationProps> = ({
  onScrollToProblem,
  onScrollToService,
  onScrollToPoint,
}) => {

  const href = window.location.href;

  const navigate = useNavigate();

  const [ isHovered, setIsHovered ] = useState(false);
  const [ isOpen, setIsOpen ] = useState(false);
  const [ companyCheck, setCompanyCheck ] = useState(false);

  useEffect(() => {
    if (typeof href === "undefined") return;
    if (href.endsWith("company")) {
      setCompanyCheck(true);
    } else {
      setCompanyCheck(false);
    }
  }, []);

  return (
    <>
    {/* desktop */}
    <div className={Styles.navigation}>
      <div className={Styles.n_left}>
        <a href="https://memorii-works.com/company">
          <img src={Logo} className={Styles.logo} />
        </a>
        {companyCheck ? 
        <div onMouseEnter={() => setIsHovered(true)} onMouseLeave={() => setIsHovered(false)}>
          <p>サービスについて</p>
          <FaAngleDown className={Styles.logo_icon} />
        </div>
        :
        <div onClick={() => navigate("/company")}>
          <p>サービスについて</p>
        </div> }
        <a href="https://apps.apple.com/jp/app/memorii-works/id1578278781" target="_blank" rel="noopener noreferrer">
          <p>学生向け就活アプリ</p>
        </a>
        <a href="https://memorii-works.com/about">
          <p>会社概要</p>
        </a>
        <a href="https://memorii-works.com/contact">
          <p>お問い合わせ</p>
        </a>
      </div>
      <div className={Styles.n_right}>
        <a href="https://memorii-works.com/company/login">
          <p>ログイン</p>
        </a>
        <a href="https://memorii-works.com/contact">
          <button>資料ダウンロード</button>
        </a>
      </div>
    
      <AnimatePresence>
        {isHovered && (
          <motion.div
            initial={{ opacity: 0, y: 10, scale: 0.95 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 10, scale: 0.95 }}
            transition={{ duration: 0.2, ease: "easeOut" }}
            style={{
              position: "absolute",
              zIndex: 1000,
            }}
            className={Styles.navigation_modal}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
          >
            <div>
              <h4 style={{cursor: "pointer"}} onClick={onScrollToProblem}>1. 業界の課題</h4>
              <h4 style={{cursor: "pointer"}} onClick={onScrollToService}>2. サービス</h4>
              <h4 style={{cursor: "pointer"}} onClick={onScrollToPoint}>3. 特徴</h4>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>

    {/* mobile */}
    <div className={Styles.navigation_mobile}>
      <img src={Logo} className={Styles.logo} />
      <div className={Styles.navigation_mobile_right}>
        <p>ログイン</p>
        <button>資料ダウンロード</button>
      </div>
      <IoReorderThreeOutline className={Styles.navigation_mobile_icon} onClick={() => setIsOpen(!isOpen)} />
    </div>

    
    <div className={`${Styles.accordion} ${isOpen ? Styles.open : ""}`}>
      <h4 style={{marginTop: "10px"}}>ページ内 遷移</h4>
      <p>1. 業界の課題</p>
      <p>2. サービス</p>
      <p>3. 特徴</p>
      <p>5. 活用までの流れ</p>
      <div className={Styles.accordion_hr}></div>
      <h4>教育機関様向けサイト</h4>
      <div className={Styles.accordion_hr}></div>
      <h4>学生向けサイト</h4>
      <div className={Styles.accordion_hr}></div>
      <h4>お問い合わせ</h4>
      <div className={Styles.accordion_hr}></div>
      <div className={Styles.links}>
        <img src={memorii} />
        <img src={Instagram} />
        <img src={Tiktok} />
      </div>
    </div>
    </>
  );
}


export default HomeNavigation;